import Swiper from 'swiper'

export default (slider, params) => new Swiper(slider, params)
